export class IncidentUpdatesDashboard {
  public body: string;
  public created_at:  string;
  public display_at:  string;
  public id:  string;
  public incident_id:  string;
  public status:  string;
  public updated_at:  string;
}
